<template>
	<div class="container">

		<el-scrollbar id="menuWarpper" style="height:calc(99%);background-color: #FFFFFF;margin-top: 0px;">
			<el-card class="main">
				<!-- <el-button class="fanhuiBtn" @click="fanhui()">返回</el-button> -->
				<div class="yonghuminglabe">实施申请</div>
				<el-button v-if="dangqianzhuangtai==true" type="primary" class="baocun" @click="BaoCunQB()" :disabled="isShanChu">保存</el-button>
				<el-button v-if="dangqianzhuangtai==false" type="primary" class="baocun" @click="BianJiQB()" :disabled="isShanChu">编辑</el-button>
				<div class="header-cona">
					<div class="maina">
						<div class="header-con-form">
							<div class="header-con-form">
								<div class="haocai">客户:</div>
								<el-input class="shishishenqinginput" v-if="dangqianzhuangtai==true" placeholder="请输入" ref="kehushurukuang"
									@change="getKefumingdan(1)" :value="kehumingcheng" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
								<label class="shishishenqinginput" v-else>kehumingcheng</label>
							</div>
							<div class="header-con-form">
								<div class="haocai">联系人:</div>
								<el-input class="shishishenqinginput" v-if="dangqianzhuangtai==true" placeholder="请输入" ref="lianxirenshurukuang"
									@change="getKefumingdan(1)" :value="lianxirenxingming" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
								<label class="shishishenqinginput" v-else>lianxirenxingming</label>
							</div>
							<div class="header-con-form">

								<div class="haocai">联系电话:</div>
								<el-input class="shishishenqinginput" v-if="dangqianzhuangtai==true" placeholder="请输入" ref="lianxidianhuashurukuang"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>
							<div class="header-con-form">

								<div class="haocai">日期:</div>
								<el-input class="shishishenqinginput" v-if="dangqianzhuangtai==true" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>

						</div>
						<div class="header-con-form">
							<div class="haocai">添加产品:</div>
							<el-input type="textarea" v-if="dangqianzhuangtai==true"
								style="width: 75%;margin-right: 10px;margin-left: 10px;margin-top: 10px;"
								:autosize="{ minRows: 2, maxRows: 8}" placeholder="请输入内容" v-model="beizhuneirong">
							</el-input>

						</div>
						<div class="header-con-form" >
							<div class="haocai">需求描述:</div>
							<el-input type="textarea" v-if="dangqianzhuangtai==true"
								style="width: 75%;margin-right: 10px;margin-left: 10px;margin-top: 10px;"
								:autosize="{ minRows: 2, maxRows: 8}" placeholder="请输入内容" v-model="beizhuneirong">
							</el-input>
						</div>
						<div class="header-con-form">
							<div class="header-con-form" >
								<div class="haocai">关联合同:</div>
								<el-input v-if="dangqianzhuangtai==true" class="shishishenqinginput" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>
						</div>
						<div class="header-con-form" v-if="dangqianzhuangtai==true">
							<div class="header-con-form">
								<div class="haocai">添加附件:</div>
								<el-input class="shishishenqinginput" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>
						</div>
						<div class="header-con-form" v-if="dangqianzhuangtai==false">
							<div class="header-con-form">
								<div class="haocai">附件:</div>
								<el-input class="shishishenqinginput" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>
						</div>
					</div>
				</div>
			</el-card>
			<el-card class="main">
				<!-- <el-button class="fanhuiBtn" @click="fanhui()">返回</el-button> -->
				<div class="yonghuminglabe">内部启动会</div>
				<div class="header-cona">
					<div class="maina">
						<div class="header-con-form">
							<div class="header-con-form">
								<div class="haocai">开始时间:</div>
								<el-input class="shishishenqinginput" v-if="dangqianzhuangtai==true" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
								<div v-if="dangqianzhuangtai==false">{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">地点:</div>
								<el-input class="shishishenqinginput" v-if="dangqianzhuangtai==true" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
								<div v-if="dangqianzhuangtai==false">{{kaishishijiannbqdh}}</div>
							</div>

						</div>
						<div class="header-con-form">
							<div class="haocai">参会人员:</div>
							<el-input type="textarea" v-if="dangqianzhuangtai==true"
								style="width: 75%;margin-right: 10px;margin-left: 10px;margin-top: 10px;"
								:autosize="{ minRows: 2, maxRows: 8}" placeholder="请输入内容" v-model="beizhuneirong">
							</el-input>
							<div v-if="dangqianzhuangtai==false">{{kaishishijiannbqdh}}</div>

						</div>
					</div>
				</div>
			</el-card>
			<el-card class="main">
				<!-- <el-button class="fanhuiBtn" @click="fanhui()">返回</el-button> -->
				<div class="yonghuminglabe">实施计划</div>
				<el-button type="primary" class="baocun" @click="ShanChu('施工项目')" :disabled="isShanChu">保存</el-button>


				<div class="header-con">
					<div class="biaoti">硬件采购</div>
					<div class="maina">

						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==true">
							<div class="haocai">耗材:</div>
							<el-input v-model="haocai" class="shishishenqinginput" placeholder="双击选择耗材" ref="kefuchaxun"
								@change="XinJian('耗材')" @keyup.enter.native="XinJian('耗材')"
								@dblclick.native="XinJian('耗材')">
							</el-input>
							<el-button @click="ShanChu('耗材')"
								style="background: #00BC2B;color: #FFFFFF;margin-top:10px;margin-right: 10px;"
								:disabled="isShanChu">从模版导入</el-button>
						</div>
						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==false">
							<div class="header-con-form">
								<div class="haocai">采购人:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">完成日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
						
						</div>
						<el-table :data="tableDatahc" @cell-dblclick="editData"  highlight-current-row resizable
							stripe @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55">
							</el-table-column>
							<el-table-column align="center" type="index" label="序号" width="50">
							</el-table-column>
							<el-table-column align="center" :key="randomKey" prop="VENDER" label="耗材">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.VENDER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.VENDER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="JOB_NUMBER" label="厂家">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.JOB_NUMBER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.JOB_NUMBER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="right">
								<template slot="header">
									<el-button @click="ShanChu('耗材')"
										style="background: #409EFF;color: #FFFFFF;margin-top:10px;margin-right: 10px;"
										:disabled="isShanChu">保存</el-button>
									<el-button @click="ShanChu('耗材')"
										style="background: #FFA0A0;color: #FFFFFF;margin-top:10px;margin-right: 10px;"
										:disabled="isShanChu">删除</el-button>
								</template>
							</el-table-column>

						</el-table>
						<div class="header-con-form" v-if="dangqianzhuangtai==true">
							<div class="header-con-form">
								<div class="haocai">负责人:</div>
								<el-input class="shishishenqinginput" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<el-date-picker v-model="jiezhirqiyjcg" style="margin-left: 10px;margin-top: 10px;"
									align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions">
								</el-date-picker>
							</div>

						</div>
						<el-divider></el-divider>


					</div>
				</div>


				<div class="yonghuminglabe"></div>


				<div class="header-con">
					<div class="biaoti">施工</div>
					<div class="maina">

						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==true">
							<div class="haocai">施工:</div>
							<el-input v-model="xiangmushishi" class="shishishenqinginput" placeholder="双击选择施工项目"
								ref="kefuchaxun" @change="XinJian('施工项目')" @keyup.enter.native="XinJian('施工项目')"
								@dblclick.native="XinJian('施工项目')">
							</el-input>
							<el-button @click="ShanChu('施工项目')"
								style="background: #00BC2B;color: #FFFFFF;margin-top:10px;margin-right: 10px;"
								:disabled="isShanChu">从模版导入</el-button>
						</div>
						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==false">
							<div class="header-con-form">
								<div class="haocai">负责人:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">测试日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">验收日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<el-button @click="ShanChu('施工项目')"
								style="background: #00BC2B;color: #FFFFFF;margin-top:10px;margin-right: 10px;margin-left: 130px;"
								:disabled="isShanChu">已完成</el-button>
						</div>
						<el-table :data="tableDatasgxm" @cell-dblclick="editData"  highlight-current-row resizable
							stripe @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55">
							</el-table-column>
							<el-table-column align="center" type="index" label="序号" width="50">
							</el-table-column>
							<el-table-column align="center" :key="randomKey" prop="VENDER" label="项目名称">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.VENDER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.VENDER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="JOB_NUMBER" label="负责人">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.JOB_NUMBER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.JOB_NUMBER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="JOB_NUMBER1" label="参与人">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.JOB_NUMBER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.JOB_NUMBER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="JOB_NUMBER2" label="截止日期">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.JOB_NUMBER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.JOB_NUMBER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="right">
								<template slot="header">
									<el-button @click="ShanChu('耗材')"
										style="background: #409EFF;color: #FFFFFF;margin-top:10px;margin-right: 10px;"
										:disabled="isShanChu">保存</el-button>
									<el-button @click="ShanChu('耗材')"
										style="background: #FFA0A0;color: #FFFFFF;margin-top:10px;margin-right: 10px;"
										:disabled="isShanChu">删除</el-button>
								</template>
							</el-table-column>

						</el-table>
						<div class="header-con-form"  v-if="dangqianzhuangtai==true">
							<div class="header-con-form">
								<div class="haocai">负责人:</div>
								<el-input class="shishishenqinginput" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<el-date-picker v-model="jiezhirqisg" style="margin-left: 10px;margin-top: 10px;"
									align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions">
								</el-date-picker>
							</div>

						</div>
						<el-divider></el-divider>

					</div>
				</div>



				<div class="yonghuminglabe"></div>


				<div class="header-con">
					<div class="biaoti">准备工作</div>
					<div class="maina">

						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==true">
							<div class="haocai">仓库基础设施:</div>
							<el-input v-model="haocai" class="shishishenqinginput" placeholder="双击选择耗材" ref="kefuchaxun"
								@change="XinJian('仓库基础设施')" @keyup.enter.native="XinJian('仓库基础设施')"
								@dblclick.native="XinJian('仓库基础设施')">
							</el-input>
							<el-button @click="ShanChu('仓库基础设施')"
								style="margin-top:10px;margin-right: 10px;background-color: #409EFF;color: #FFFFFF;"
								:disabled="isShanChu">仓库基础设施</el-button>
						</div>
						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==false">
							<div class="header-con-form">
								<div class="haocai">负责人:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">测试日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">验收日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<el-button @click="ShanChu('施工项目')"
								style="background: #00BC2B;color: #FFFFFF;margin-top:10px;margin-right: 10px;margin-left: 130px;"
								:disabled="isShanChu">已完成</el-button>
						</div>
						<el-table :data="tableDatackjcss" @cell-dblclick="editData"  highlight-current-row
							resizable stripe @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55">
							</el-table-column>
							<el-table-column align="center" type="index" label="序号" width="50">
							</el-table-column>
							<el-table-column align="center" :key="randomKey" prop="VENDER" label="耗材">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.VENDER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.VENDER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="JOB_NUMBER" label="厂家">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.JOB_NUMBER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.JOB_NUMBER }}</span>
								</template>
							</el-table-column>

						</el-table>
						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==true">
							<div class="haocai">辅助硬件设备:</div>
							<el-input v-model="haocai" class="shishishenqinginput" placeholder="双击选择耗材" ref="kefuchaxun"
								@change="XinJian('辅助硬件设备')" @keyup.enter.native="XinJian('辅助硬件设备')"
								@dblclick.native="XinJian('辅助硬件设备')">
							</el-input>
							<el-button @click="ShanChu('辅助硬件设备')"
								style="margin-top:10px;margin-right: 10px;background-color: #409EFF;color: #FFFFFF;"
								:disabled="isShanChu">辅助硬件设备</el-button>
						</div>
						<el-table :data="tableDatackfzyjsb" @cell-dblclick="editData"  highlight-current-row
							resizable stripe @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55">
							</el-table-column>
							<el-table-column align="center" type="index" label="序号" width="50">
							</el-table-column>
							<el-table-column align="center" :key="randomKey" prop="VENDER" label="耗材">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.VENDER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.VENDER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="JOB_NUMBER" label="厂家">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.JOB_NUMBER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.JOB_NUMBER }}</span>
								</template>
							</el-table-column>

						</el-table>
						<div class="header-con-form" v-if="dangqianzhuangtai==true">
							<div class="header-con-form">
								<div class="haocai">负责人:</div>
								<el-input class="shishishenqinginput" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<el-date-picker v-model="jiezhirqizbgz" style="margin-left: 10px;margin-top: 10px;"
									align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions">
								</el-date-picker>
							</div>

						</div>
						<el-divider></el-divider>

					</div>
				</div>

				<div class="yonghuminglabe"></div>


				<div class="header-con">
					<div class="biaoti">软件</div>
					<div class="maina">

						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==true">
							<div class="haocai">产品名称:</div>
							<el-input v-model="haocai" class="shishishenqinginput" placeholder="双击选择产品名称" ref="kefuchaxun"
								@change="XinJian('产品名称')" @keyup.enter.native="XinJian('产品名称')"
								@dblclick.native="XinJian('产品名称')">
							</el-input>
							<el-button type="danger" @click="ShanChu('产品名称')" style="margin-top:10px;margin-right: 10px;"
								:disabled="isShanChu">从模板导入</el-button>
						</div>
						<div class="header-con-form" style="margin-bottom: 10px;">
							<div class="haocai">OMS系统</div>
						</div>
						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==false">
							<div class="header-con-form">
								<div class="haocai">负责人:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">测试日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">验收日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<el-button @click="ShanChu('施工项目')"
								style="background: #00BC2B;color: #FFFFFF;margin-top:10px;margin-right: 10px;margin-left: 130px;"
								:disabled="isShanChu">已完成</el-button>
						</div>
						<el-table :data="tableDatahc" @cell-dblclick="editData"  highlight-current-row resizable
							stripe @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55">
							</el-table-column>
							<el-table-column align="center" type="index" label="序号" width="50">
							</el-table-column>
							<el-table-column align="center" :key="randomKey" prop="VENDER" label="耗材">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.VENDER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.VENDER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="JOB_NUMBER" label="厂家">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.JOB_NUMBER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.JOB_NUMBER }}</span>
								</template>
							</el-table-column>

						</el-table>
						<div class="header-con-form" v-if="dangqianzhuangtai==true">
							<div class="header-con-form">
								<div class="haocai">负责人:</div>
								<el-input class="shishishenqinginput" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<el-date-picker v-model="jiezhirqirj" style="margin-left: 10px;margin-top: 10px;"
									align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions">
								</el-date-picker>
							</div>

						</div>
						<el-divider></el-divider>

					</div>
				</div>

				<div class="yonghuminglabe"></div>
				<div class="header-con">
					<div class="biaoti">验收</div>
					<div class="maina">

						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==true">
							<div class="haocai">产品名称:</div>
							<el-input v-model="haocai" class="shishishenqinginput" placeholder="双击选择产品名称" ref="kefuchaxun"
								@change="XinJian('产品名称')" @keyup.enter.native="XinJian('产品名称')"
								@dblclick.native="XinJian('产品名称')">
							</el-input>
							<el-button type="danger" @click="ShanChu('产品名称')" style="margin-top:10px;margin-right: 10px;"
								:disabled="isShanChu">从模板导入</el-button>
						</div>
						<div class="header-con-form" style="margin-bottom: 10px;">
							<div class="haocai">OMS系统</div>
						</div>
						<div class="header-con-form" style="margin-bottom: 10px;" v-if="dangqianzhuangtai==false">
							<div class="header-con-form">
								<div class="haocai">负责人:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">测试日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<div class="header-con-form">
								<div class="haocai">验收日期:</div>
								<div>{{kaishishijiannbqdh}}</div>
							</div>
							<el-button @click="ShanChu('施工项目')"
								style="background: #00BC2B;color: #FFFFFF;margin-top:10px;margin-right: 10px;margin-left: 130px;"
								:disabled="isShanChu">已完成</el-button>
						</div>
						<el-table :data="tableDatahc" @cell-dblclick="editData" v-if="dangqianzhuangtai==true"  highlight-current-row resizable
							stripe @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55">
							</el-table-column>
							<el-table-column align="center" type="index" label="序号" width="50">
							</el-table-column>
							<el-table-column align="center" :key="randomKey" prop="VENDER" label="耗材">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.VENDER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.VENDER }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="JOB_NUMBER" label="厂家">
								<template slot-scope="scope">
									<el-input v-if="scope.row[scope.column.property + 'isShow']"
										:ref="scope.column.property" v-model="scope.row.JOB_NUMBER"
										@blur="alterData(scope.row,scope.column)"></el-input>
									<span v-else>{{ scope.row.JOB_NUMBER }}</span>
								</template>
							</el-table-column>

						</el-table>
						<div class="header-con-form" >
							<div class="header-con-form">
								<div class="haocai">负责人:</div>
								<el-input class="shishishenqinginput" placeholder="请输入" ref="kefuchaxun"
									@change="getKefumingdan(1)" @keyup.enter.native="getKefumingdan(1)">
								</el-input>
							</div>
							<div class="header-con-form">
								<div class="haocai">截止日期:</div>
								<el-date-picker v-model="jiezhirqiys" style="margin-left: 10px;margin-top: 10px;"
									align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions">
								</el-date-picker>
							</div>

						</div>
						<el-divider></el-divider>

					</div>
				</div>
			</el-card>
		</el-scrollbar>



	</div>
</template>

<script>
	import PinyinMatch from "pinyin-match";
	export default {
		name: "mobanchaxun",
		data() {
			return {
				kaishishijiannbqdh:"",
				dangqianzhuangtai:false,
				jiezhirqiys:"",
				jiezhirqizbgz:"",
				jiezhirqisg:"",
				jiezhirqirj:"",
				jiezhirqiyjcg:"",
				randomKey: Math.random(),
				multipleSelection: "",
				mobanzhuangtai: -1,
				mobanzhuangtaiList: [{
						Code: -1,
						Name: "全部",
					}, {
						Code: 1,
						Name: "禁用",
					},
					{
						Code: 2,
						Name: "启用",
					}
				],
				PROJECT: "", //项目
				xiangmushishi: "", //实施项目名称
				tableDatasgxm: [], //施工项目数组
				tableDatackjcss: [], //仓库基础设施数组
				tableDatackfzyjsb: [], //辅助硬件设备数组
				tableDatajcfw: [], //基础服务数组
				tableDataxtdj: [], //系统对接数组
				tableDatassjd: [], //实施阶段数组
				tableDatajcsjcz: [], //基础数据初装数组
				tableDatahc: [], //耗材数组
				isShanChu: false, //删除按钮判断
				isBaoCun: false, //保存按钮显示判断
				isXinJian: false, //添加按钮显示判断
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '一周前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}]
				},
				haocai: "", //耗材
				beizhuneirong: "", //备注
				formDialogsg: false,
				formDialogyj: false,
				formDialogrj: false,
				formDialogzb: false,
				isQiYong: false,
				isChaXun: false,
				isXiangQing: false,
				dqcxzt: 'qb',
				dangqiandanhao: "",
				jdxzyjwcsj: false,
				renyuan: JSON.parse(localStorage.getItem("userInfo")).ROLE,
				EchartsHeight: (document.body.clientHeight - 200) + 'px',
				EchartsHeighta: (document.body.clientHeight / 3) + 'px',
				EchartsHeightb: (document.body.clientHeight / 4) + 'px',
				EchartsHeightc: (document.body.clientHeight / 5) + 'px',
				WenTileixingList: [],
				staffcopy: [],
				staff: [], //产品线
				staffz: [], //产品线
				chanpinxian: "", //产品线
				kaishishijian: "",
				jieshushijian: "",
				loading: false,
				formDialogkf: false,
				currPage: 1,
				pageSize: 50,
				allPage: 0,
				currPagekf: 1,
				pageSizekf: 50,
				allPagekf: 0,
				tableDatakf: [],
				tableData: [],
				yujiwanchengshijian: '',
				form: {
					mobanmingcheng: "",
				},
			};
		},

		mounted() {
			const that = this;
			window.onresize = () => {
				// return (() => {
				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = (window.screenHeight - 200) + 'px'
				that.EchartsHeighta = (window.screenHeight / 3) + 'px'
				that.EchartsHeightb = (window.screenHeight / 4) + 'px',
					that.EchartsHeightb = (document.body.clientHeight / 5) + 'px',

					that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
				// })()
			}

			this.addDate();
			this.getPerson();
			this.currPage = 1;
			console.log(this.dqcxzt)
			this.ChaXun(this.currPage);

		},
		activated() {
			const that = this;
			window.onresize = () => {
				// return (() => {
				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = (window.screenHeight - 200) + 'px'
				that.EchartsHeighta = (window.screenHeight / 3) + 'px'
				that.EchartsHeightb = (window.screenHeight / 4) + 'px',
					that.EchartsHeightb = (document.body.clientHeight / 5) + 'px',
					that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
				// })()
			}
			this.addDate();
			this.getPerson();
			this.currPage = 1;
			console.log(this.dqcxzt)
			this.ChaXun(this.currPage);

		},
		beforeRouteEnter(to, form, next) {
			next(vm => {
				console.log(vm.dqcxzt)
				vm.ChaXun(1)

			})

		},
		methods: {
			BaoCunQB(){
				this.dangqianzhuangtai=false;
			},
			BianJiQB(){
				this.dangqianzhuangtai=true;
				
			},
			dianjichanpinxian() {
				this.staff = this.staffz;
				this.ChaXun(1)
			},
			bindSelectChange(val) {

				if (val) {
					this.staff = this.staffcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.staff = this.staffcopy
				}

			},

			/**获取产品线 */
			getPerson() {
				this.loading = true;


				this.$request({
						method: "GET",
						url: "Dictionary/GetProducts",
					})
					.then((res) => {

						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {

							this.staff = res.Data;
							this.staffz = res.Data;
							this.staffcopy = this.staff;


						}

					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			closeDialog() {
				// this.xxx = ''; //清空数据
				console.log("aaaa")
				this.form.mobanmingcheng = "";
				this.beizhuneirong = "";
				this.tableDatasgxm = []; //施工项目数组
				this.tableDatackjcss = []; //仓库基础设施数组
				this.tableDatackfzyjsb = []; //辅助硬件设备数组
				this.tableDatajcfw = []; //基础服务数组
				this.tableDataxtdj = []; //系统对接数组
				this.tableDatassjd = []; //实施阶段数组
				this.tableDatajcsjcz = []; //基础数据初装数组
				this.tableDatahc = []; //耗材数组
			},
			editData(row, column) {
				console.log(row)
				row[column.property + "isShow"] = true
				//refreshTable是table数据改动时，刷新table的
				this.refreshTable()
				this.$nextTick(() => {
					this.$refs[column.property] && this.$refs[column.property].focus()
				})


			},
			refreshTable() {
				this.randomKey = Math.random()
				console.log("this.randomKey", this.randomKey)
			},
			alterData(row, column) {
				console.log(row, column)
				row[column.property + "isShow"] = false
				this.refreshTable()
			},
			ShanChu(neirong) {
				if (neirong == "耗材") {
					var newArr = this.tableDatahc.filter((itemA) => {
						console.log('itemA', itemA)
						return this.multipleSelection.every(itemB => {
							console.log(itemA, itemB)
							return itemB !== itemA

						})
					})
					console.log(newArr)

					this.tableDatahc = newArr;
				} else if (neirong == "仓库基础设施") {
					var newArrckjcss = this.tableDatackjcss.filter((itemA) => {
						console.log('itemA', itemA)
						return this.multipleSelection.every(itemB => {
							console.log(itemA, itemB)
							return itemB !== itemA

						})
					})
					console.log(newArrckjcss)

					this.tableDatackjcss = newArrckjcss;
				} else if (neirong == "施工项目") {
					var newArrsgxm = this.tableDatasgxm.filter((itemA) => {
						console.log('itemA', itemA)
						return this.multipleSelection.every(itemB => {
							console.log(itemA, itemB)
							return itemB !== itemA

						})
					})
					console.log(newArrsgxm)

					this.tableDatasgxm = newArrsgxm;
					var newArrckfzyjsb = this.tableDatackfzyjsb.filter((itemA) => {
						console.log('itemA', itemA)
						return this.multipleSelection.every(itemB => {
							console.log(itemA, itemB)
							return itemB !== itemA

						})
					})
					console.log(newArrckfzyjsb)

					this.tableDatackfzyjsb = newArrckfzyjsb;

				} else if (neirong == "基础服务") {
					var newArrjcfw = this.tableDatajcfw.filter((itemA) => {
						console.log('itemA', itemA)
						return this.multipleSelection.every(itemB => {
							console.log(itemA, itemB)
							return itemB !== itemA

						})
					})
					console.log(newArrjcfw)

					this.tableDatajcfw = newArrjcfw;
					var newArrxtdj = this.tableDataxtdj.filter((itemA) => {
						console.log('itemA', itemA)
						return this.multipleSelection.every(itemB => {
							console.log(itemA, itemB)
							return itemB !== itemA

						})
					})
					console.log(newArrxtdj)

					this.tableDataxtdj = newArrxtdj;
					var newArrssjd = this.tableDatassjd.filter((itemA) => {
						console.log('itemA', itemA)
						return this.multipleSelection.every(itemB => {
							console.log(itemA, itemB)
							return itemB !== itemA

						})
					})
					console.log(newArrssjd)

					this.tableDatassjd = newArrssjd;
					var newArrjcsjcz = this.tableDatajcsjcz.filter((itemA) => {
						console.log('itemA', itemA)
						return this.multipleSelection.every(itemB => {
							console.log(itemA, itemB)
							return itemB !== itemA

						})
					})
					console.log(newArrjcsjcz)

					this.tableDatajcsjcz = newArrjcsjcz;

				}
			},
			xiangqing(row) {
				// this.formDialog = true;
				this.isXiangQing = true;
				this.scoped = true;

				this.$request({
						method: "GET",
						url: "Template/GetTemplate?code=" + encodeURIComponent(row.row.CODE),
					})
					.then((res) => {
						this.isXiangQing = false;
						console.log(res)
						if (res.Code == "0" || res.Code == 0 || res.Code == true) {
							if (res.Data.PROJECT == "施工模版") {
								this.formDialogsg = true;
								this.form.mobanmingcheng = res.Data.TITLE;
								this.beizhuneirong = res.Data.REMARK;
								this.PROJECT = res.Data.PROJECT;

								this.tableDatasgxm = res.Data.WosTemplateEntries; //施工项目数组

							} else if (res.Data.PROJECT == "硬件采购模版") {
								this.formDialogyj = true;
								this.form.mobanmingcheng = res.Data.TITLE;
								this.beizhuneirong = res.Data.REMARK;
								this.PROJECT = res.Data.PROJECT;

								this.tableDatahc = res.Data.WosTemplateEntries; //耗材数组
							} else if (res.Data.PROJECT == "准备工作模版") {
								this.formDialogzb = true;
								this.form.mobanmingcheng = res.Data.TITLE;
								this.beizhuneirong = res.Data.REMARK;
								this.PROJECT = res.Data.PROJECT;
								this.tableDatackjcss = res.Data.WosTemplateEntries; //仓库基础设施数组
								this.tableDatackfzyjsb = []; //辅助硬件设备数组

							} else {
								this.formDialogrj = true;
								this.form.mobanmingcheng = res.Data.TITLE;
								this.beizhuneirong = res.Data.REMARK;
								this.PROJECT = res.Data.PROJECT;
								this.tableDatajcfw = res.Data.WosTemplateEntries; //施工项目数组
								this.tableDataxtdj = []; //系统对接数组
								this.tableDatajcsjcz = []; //基础数据初装
								this.tableDatassjd = []; //实施阶段数组
							}
						}
						// this.$message({
						// 	message: value + res.Msg,
						// 	type: "success",
						// });

					})
					.catch((err) => {
						this.isXiangQing = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			JinYong(row) {
				console.log(row)
				this.genggaizhuangtai("禁用", row.row.CODE)
			},
			QiYong(row) {
				console.log(row)
				this.genggaizhuangtai("启用", row.row.CODE)
			},
			ShanChuMoBan(row) {
				console.log(row)
				this.genggaizhuangtai("删除", row.row.CODE)
			},
			/**更改状态*/
			genggaizhuangtai(value, CODE) {
				var zhuangtai = '1';
				if (value == "禁用") {
					zhuangtai = '1';
				} else if (value == "删除") {
					zhuangtai = '0';
				} else {
					zhuangtai = '2';
				}
				let data = {

					CODE: CODE, //序号
					STATUS: zhuangtai, //客服工号


				};
				// this.formDialog = true;
				this.isQiYong = true;
				this.scoped = true;

				this.$request({
						method: "post",
						url: "Template/ModifyStatus",
						data: data,
					})
					.then((res) => {
						this.isQiYong = false;
						this.$message({
							message: value + res.Msg,
							type: "success",
						});
						this.ChaXun(this.currPage)

					})
					.catch((err) => {
						this.isQiYong = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log(this.multipleSelection)
			},
			dianzhuangtai() {
				this.ChaXun(1)
			},

			XinJian(gongneng) {

				var arr = [];
				if (this.tableDatasgxm.length != 0 || this.tableDatackjcss.length != 0 || this.tableDatackfzyjsb.length !=
					0 ||
					this.tableDatajcfw.length != 0 || this.tableDataxtdj.length != 0 || this.tableDatassjd.length != 0 ||
					this.tableDatajcsjcz.length != 0 || this.tableDatahc.length != 0) {

					for (var xm in this.tableDatasgxm) {
						arr.push(this.tableDatasgxm[xm])
					}
					for (var ckjcss in this.tableDatackjcss) {
						arr.push(this.tableDatackjcss[ckjcss])
					}
					for (var ckfzyjsb in this.tableDatackfzyjsb) {
						arr.push(this.tableDatackfzyjsb[ckfzyjsb])
					}
					for (var jcfw in this.tableDatajcfw) {
						arr.push(this.tableDatajcfw[jcfw])
					}
					for (var xtdj in this.tableDataxtdj) {
						arr.push(this.tableDataxtdj[xtdj])
					}
					for (var ssjd in this.tableDatassjd) {
						arr.push(this.tableDatassjd[ssjd])
					}
					for (var jcsjcz in this.tableDatajcsjcz) {
						arr.push(this.tableDatajcsjcz[jcsjcz])
					}
					for (var hc in this.tableDatahc) {
						arr.push(this.tableDatahc[hc])
					}
				}

				if (gongneng == "仓库基础设施") {
					this.tableDatackjcss.push({
						"ID": arr.length,

						"MODULE": gongneng,

						"TITLE": this.form.mobanmingcheng,

						"QUANTITY": 0,

						"VENDER": ""
					})
				} else if (gongneng == "施工项目") {
					this.tableDatasgxm.push({
						"ID": arr.length,

						"MODULE": gongneng,

						"TITLE": this.form.mobanmingcheng,

						"QUANTITY": 0,

						"VENDER": ""
					})
					console.log(this.tableDatasgxm)

				} else if (gongneng == "辅助硬件设备") {
					this.tableDatackfzyjsb.push({
						"ID": arr.length,

						"MODULE": gongneng,

						"TITLE": this.form.mobanmingcheng,

						"QUANTITY": 0,

						"VENDER": ""
					})
				} else if (gongneng == "基础服务") {
					this.tableDatajcfw.push({
						"ID": arr.length,

						"MODULE": gongneng,

						"TITLE": this.form.mobanmingcheng,

						"QUANTITY": 0,

						"VENDER": ""
					})
				} else if (gongneng == "系统对接") {
					this.tableDataxtdj.push({
						"ID": arr.length,

						"MODULE": gongneng,

						"TITLE": this.form.mobanmingcheng,

						"QUANTITY": 0,

						"VENDER": ""
					})
				} else if (gongneng == "实施阶段") {
					this.tableDatassjd.push({
						"ID": arr.length,

						"MODULE": gongneng,

						"TITLE": this.form.mobanmingcheng,

						"QUANTITY": 0,

						"VENDER": ""
					})
				} else if (gongneng == "基础数据初装") {
					this.tableDatajcsjcz.push({
						"ID": arr.length,

						"MODULE": gongneng,

						"TITLE": this.form.mobanmingcheng,

						"QUANTITY": 0,

						"VENDER": ""
					})
				} else if (gongneng == "耗材") {
					console.log(gongneng)
					this.tableDatahc.push({
						"ID": arr.length,

						"MODULE": gongneng,

						"TITLE": this.form.mobanmingcheng,

						"QUANTITY": 0,

						"VENDER": ""
					})
				}
			},

			guanbijiedantk() {
				this.jdxzyjwcsj = false;
			},
			BaoCun() {

				var arr = [];
				if (this.tableDatasgxm.length == 0 && this.tableDatackjcss.length == 0 && this.tableDatackfzyjsb.length ==
					0 &&
					this.tableDatajcfw.length == 0 && this.tableDataxtdj.length == 0 && this.tableDatassjd.length == 0 &&
					this.tableDatajcsjcz.length == 0 && this.tableDatahc.length == 0) {
					return;
				} else {
					for (var xm in this.tableDatasgxm) {
						var item = {
							"ID": this.tableDatasgxm[xm].ID,

							"MODULE": this.tableDatasgxm[xm].MODULE,

							"TITLE": this.form.mobanmingcheng,

							"QUANTITY": 0,

							"VENDER": ""
						}
						this.tableDatasgxm.splice(xm, 1, item)
						arr.push(this.tableDatasgxm[xm])
					}
					for (var ckjcss in this.tableDatackjcss) {
						var itema = {
							"ID": this.tableDatackjcss[ckjcss].ID,

							"MODULE": this.tableDatackjcss[ckjcss].MODULE,

							"TITLE": this.form.mobanmingcheng,

							"QUANTITY": 0,

							"VENDER": ""
						}
						this.tableDatackjcss.splice(ckjcss, 1, itema)
						arr.push(this.tableDatackjcss[ckjcss])
					}
					for (var ckfzyjsb in this.tableDatackfzyjsb) {
						var itemb = {
							"ID": this.tableDatackfzyjsb[ckfzyjsb].ID,

							"MODULE": this.tableDatackfzyjsb[ckfzyjsb].MODULE,

							"TITLE": this.form.mobanmingcheng,

							"QUANTITY": 0,

							"VENDER": ""
						}
						this.tableDatackfzyjsb.splice(ckfzyjsb, 1, itemb)
						arr.push(this.tableDatackfzyjsb[ckfzyjsb])
					}
					for (var jcfw in this.tableDatajcfw) {
						var itemc = {
							"ID": this.tableDatajcfw[jcfw].ID,

							"MODULE": this.tableDatajcfw[jcfw].MODULE,

							"TITLE": this.form.mobanmingcheng,

							"QUANTITY": 0,

							"VENDER": ""
						}
						this.tableDatajcfw.splice(jcfw, 1, itemc)
						arr.push(this.tableDatajcfw[jcfw])
					}
					for (var xtdj in this.tableDataxtdj) {
						var itemd = {
							"ID": this.tableDataxtdj[xtdj].ID,

							"MODULE": this.tableDataxtdj[xtdj].MODULE,

							"TITLE": this.form.mobanmingcheng,

							"QUANTITY": 0,

							"VENDER": ""
						}
						this.tableDataxtdj.splice(xtdj, 1, itemd)
						arr.push(this.tableDataxtdj[xtdj])
					}
					for (var ssjd in this.tableDatassjd) {
						var iteme = {
							"ID": this.tableDatassjd[ssjd].ID,

							"MODULE": this.tableDatassjd[ssjd].MODULE,

							"TITLE": this.form.mobanmingcheng,

							"QUANTITY": 0,

							"VENDER": ""
						}
						this.tableDatassjd.splice(ssjd, 1, iteme)
						arr.push(this.tableDatassjd[ssjd])
					}
					for (var jcsjcz in this.tableDatajcsjcz) {
						var itemf = {
							"ID": this.tableDatajcsjcz[jcsjcz].ID,

							"MODULE": this.tableDatajcsjcz[jcsjcz].MODULE,

							"TITLE": this.form.mobanmingcheng,

							"QUANTITY": 0,

							"VENDER": ""
						}
						this.tableDatajcsjcz.splice(jcsjcz, 1, itemf)
						arr.push(this.tableDatajcsjcz[jcsjcz])
					}
					for (var hc in this.tableDatahc) {
						var itemg = {
							"ID": this.tableDatahc[hc].ID,

							"MODULE": this.tableDatahc[hc].MODULE,

							"TITLE": this.form.mobanmingcheng,

							"QUANTITY": 0,

							"VENDER": ""
						}
						this.tableDatahc.splice(hc, 1, itemg)
						arr.push(this.tableDatahc[hc])
					}
				}
				let data = {
					CODE: "",
					TITLE: this.form.mobanmingcheng,
					PROJECT: this.PROJECT,
					REMARK: this.beizhuneirong,
					TYPE: 2003,
					WosTemplateEntries: arr,
				};


				this.isBaoCun = true;

				this.$request({
						method: "post",
						url: "Template/Edit",
						data: data,
					})
					.then(() => {
						this.isBaoCun = false;
						this.$message({
							message: "提交成功啦！",
							type: "success",
						});
						this.ChaXun(1)
						this.tableDatasgxm = [], //施工项目数组
							this.tableDatackjcss = [], //仓库基础设施数组
							this.tableDatackfzyjsb = [], //辅助硬件设备数组
							this.tableDatajcfw = [], //基础服务数组
							this.tableDataxtdj = [], //系统对接数组
							this.tableDatassjd = [], //实施阶段数组
							this.tableDatajcsjcz = [], //基础数据初装数组
							this.tableDatahc = [], //耗材数组
							this.beizhuneirong = "",
							this.form.mobanmingcheng = "",
							this.PROJECT = "",
							this.formDialogsg = false;
						this.formDialogyj = false;
						this.formDialogzb = false;
						this.formDialogrj = false;
						this.formDialogkf = false;


					})
					.catch((err) => {
						this.isBaoCun = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});

			},
			//客户双击
			handledbClick(row) {
				this.kehumingchengxjgd = row.BUSINESSNAME;
				this.kehubianhaoxjgd = row.BUSINESSCODE;
				this.formxjgd.name = row.CONTACT;
				this.formxjgd.dianhua = row.TELEPHONE;
				this.formxzkhlog = false;
				if (this.kehumingchengxjgd != "") {
					this.xuanzekehuxjgd = this.kehumingchengxjgd;
				} else {
					this.xuanzekehuxjgd = "";
				}
			},
			//查询
			ChaXun(index) {
				this.currPage = index;
				this.loading = true;
				this.isChaXun = true;
				let url = 'Template/GetTemplateList?template=' + encodeURIComponent(this.chanpinxian) +
					"&status=" +
					encodeURIComponent(
						this.mobanzhuangtai) +
					"&startDate=" +
					encodeURIComponent(
						this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
						.jieshushijian + " 23:59:59") + "&pageIndex=" + encodeURIComponent(index) +
					"&pageSize=" + encodeURIComponent(this.pageSize);

				this.$request({
						method: "GET",
						url: url


					})
					.then((res) => {
						this.isChaXun = false;
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.tableData = res.Data;
						}
						if (this.tableData.length > 0) {
							for (var i in this.tableData) {
								if (this.tableData[i].INFO_STATUS == 0) {
									this.$set(this.tableData[i], 'INFO_STATUS1', '已撤销')
								} else if (this.tableData[i].INFO_STATUS == 1) {
									this.$set(this.tableData[i], 'INFO_STATUS1', '已发起')
								} else if (this.tableData[i].INFO_STATUS == 2) {
									this.$set(this.tableData[i], 'INFO_STATUS1', '已接单')
								} else if (this.tableData[i].INFO_STATUS == 3) {
									this.$set(this.tableData[i], 'INFO_STATUS1', '已处理')
								} else if (this.tableData[i].INFO_STATUS == 4) {
									this.$set(this.tableData[i], 'INFO_STATUS1', '已驳回')
								} else if (this.tableData[i].INFO_STATUS == 5) {
									this.$set(this.tableData[i], 'INFO_STATUS1', '已完成')
								}
								for (var j in this.staff) {
									if (this.tableData[i].PRODUCT_LINE == this.staff[j].Code) {
										this.$set(this.tableData[i], 'PRODUCT_LINE1', this.staff[j].Name)
									}
								}
								for (var z in this.WenTileixingList) {
									if (this.tableData[i].INFO_TYPE == this.WenTileixingList[z].Code) {
										this.$set(this.tableData[i], 'INFO_TYPE1', this.WenTileixingList[z].Name)
									}
								}


							}
						}
						this.allPage = res.Total;
					})
					.catch((err) => {
						this.isChaXun = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});

			},

			ShiGong() {
				this.PROJECT = "施工模版";
				this.formDialogsg = true;
			},
			YingJian() {
				this.PROJECT = "硬件采购模版";
				this.formDialogyj = true;
			},
			ZhunBei() {
				this.PROJECT = "准备工作模版";
				this.formDialogzb = true;
			},
			RuanJian() {
				this.formDialogrj = true;
			},
			xinjianmoban() {
				// this.dangqiandanhao = row.row.CODE;
				this.formDialogkf = true
				// this.getKefumingdan(1)
				// this.$nextTick(() => {
				// 	this.$refs.kefuchaxun.focus()
				// })
			},
			/**获取客服名单 */
			getKefumingdan(index) {
				this.currPagekf = index;

				this.loading = true;

				this.$request({
						method: "GET",
						url: 'ACCOUNT/GetServiceAccountList?zh=' + encodeURIComponent(this.form.mobanmingcheng) +
							"&status=-1&pageIndex=" + encodeURIComponent(index) + "&pageSize=" +
							encodeURIComponent(
								this
								.pageSizekf),

					})
					.then((res) => {

						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.tableDatakf = res.Data;

						}
						if (this.tableDatakf.length > 0) {
							for (var i in this.tableDatakf) {
							
							
							var bdcpx = this.tableDatakf[i].PRODUCT_LINE.split(',');
							var xin=[];
							for(var z in bdcpx){
								for (var j in this.staff) {
									if (bdcpx[z] == this.staff[j].Code) {
										xin.push(this.staff[j].Name)
										this.$set(this.tableDatakf[i], 'PRODUCT_LINE1', xin.join(','))
									}
									
								}
								
							}
								
						
						
							}
						}
						this.allPagekf = res.Total;
					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},



			getPath() {
				this.$router.push({
					path: "/login",
				});
			},

			addDate() {
				let nowDate = new Date();
				let date = {
					year: nowDate.getFullYear(),
					month: nowDate.getMonth() + 1,
					date: nowDate.getDate(),
				};
				console.log(date);

				if (date.month > 0 && date.month < 10) {
					date.month = '0' + date.month; //补齐
				}
				if (date.date > 0 && date.date < 10) {
					date.date = '0' + date.date; //补齐
				}
				nowDate.setMonth(nowDate.getMonth() - 1);
				var thirtyYear = nowDate.getFullYear();
				var thirtyMonth = nowDate.getMonth() + 1;
				var thirtyDay = nowDate.getDate();
				if (thirtyMonth >= 1 && thirtyMonth <= 9) {
					thirtyMonth = "0" + thirtyMonth;
				}
				if (thirtyDay >= 1 && thirtyDay <= 9) {
					thirtyDay = "0" + thirtyDay;
				}
				var monthDate = thirtyYear + "-" + thirtyMonth + "-" + '01';
				console.log(date.date, monthDate);
				// let shijianshuzu = [];
				let shijian = date.year + "-" + date.month + "-" + date.date;

				// shijianshuzu.push(shijian);
				// shijianshuzu.push(shijian);
				this.kaishishijian = monthDate;
				this.jieshushijian = shijian;
				this.yujiwanchengshijian = shijian + " 23:59:59";
			},

			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.currPage = 1;
				this.ChaXun(this.currPage);
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val;
				this.ChaXun(this.currPage);
			},
			/**刷新表格数据 */
			handleRefresh() {
				this.currPage = 1;
				this.ChaXun(this.currPage);
			},
			/**分页size改变 */
			hanSiChangekf(val) {
				this.pageSizekf = val;
				this.currPagekf = 1;
				this.getKefumingdan(1);
			},
			/**当前页改变 */
			hanCurrChangekf(val) {
				this.currPagekf = val;
				this.getKefumingdan(this.currPagekf);
			},
			/**刷新表格数据 */
			handleRefreshkf() {
				this.currPagekf = 1;
				this.getKefumingdan(this.currPagekf);
			},




		},
	};
</script>

<style scoped>
	.container {
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
	}

	/* 主体容器 */
	.main {
		height: 100%;
		overflow: hidden;
		background-color: #fff;
		padding: 0px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.baocun {
		margin-top: 0px;
		margin-right: 30px;
		float: right;
	}

	.yonghuminglabe {
		margin-top: 0px;
		margin-left: 30px;
		margin-bottom: 0px;
		display: inline-block;
		font-size: 20px;
		font-weight: bold;
		color: #303133;
		line-height: 0px;
	}
	.header-cona {
		margin-left: 50px;
		margin-right: 50px;
		margin-top: 0px;
	}

	.header-con {
		margin-left: 50px;
		margin-right: 50px;
		margin-top: 20px;
		padding: 20px;
		border: 1px solid #DCDFE6;
		border-radius: 10px;
	}

	.header-con-form {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		word-wrap: break-word;
		margin-top: 10px;

	}

	.shishishenqinginput {
		width: 200px;
		margin-right: 10px;
		margin-left: 10px;
		margin-top: 10px;
	}

	.haocai {
		width: 120px;
		margin-top: 10px;
		text-align: right;
		color: #909399;
		font-size: 16px;
	}

	.biaoti {
		width: 100%;
		text-align: center;
		font-size: 24px;
		font-family: Microsoft YaHei-Regular, Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		-webkit-background-clip: text;
	}
</style>
